import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["flash"]

  connect() {
    this.processFlashes();
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            if (node.matches('[data-flashes-target="flash"]')) {
              this.processFlash(node);
            }
          });
        }
      });
    });

    const targetNode = this.element;
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
  }

  processFlashes() {
    if (this.hasFlashTarget) {
      this.flashTargets.forEach(flash => this.processFlash(flash));
    }
  }

  processFlash(flash) {
    flash.classList.remove('fade-out');
    setTimeout(() => {
      flash.classList.add('fade-out');
      flash.remove();
    }, 4000);
  }

  closeAlert(event) {
    event.target.closest('.flash').remove()
  }

  disconnect() {
    clearTimeout(this.timeoutId)
    this.flashTargets.forEach(flash => flash.remove())
  }
}
